/*
 * Whether hub-backend has blocked this retailer's Hub access (CPMT-5928).
 * Shared because the takeover gate and the takeover's own retailer switcher
 * have to agree: if they drifted, a blocked merchant would get a switcher
 * leading straight back to the takeover. Absent migration data means not
 * blocked — legacy retailers and environments that send no migration data.
 */
export default migration =>
  Boolean(migration && migration.is_hub_access_blocked);
